import { z } from "zod";
import { queryOptions } from "@tanstack/react-query";
import { axiosInstance } from "./axios";

const lineAVGSchema = z.object({
    lineName: z.string(),
    defenseAVG: z.number(),
    offensiveAVG: z.number(),
    teamPlayAVG: z.number(),
    effortAVG: z.number(),
    bonusAVG: z.number(),
    totalAVG: z.number(),
});

const matchAVGSchema = z.object({
    matchId: z.number(),
    enemyTeam: z.string(),
    lineAVG: z.array(lineAVGSchema),
    result: z.string(),
    chosenTeamScore: z.number(),
    opponentScore: z.number(),
});

const lineScoresResponseSchema = z.object({
    matchesAVG: z.array(matchAVGSchema),
});

export type TournamentLineAVG = z.infer<typeof lineAVGSchema>;
export type TournamentMatchAVG = z.infer<typeof matchAVGSchema>;
export type TournamentLineScoresResponse = z.infer<typeof lineScoresResponseSchema>;

export const fetchTournamentLineScores = async (tournamentId: number, teamId: number): Promise<TournamentLineScoresResponse> => {
    const response = await axiosInstance.get(`${tournamentId}/${teamId}/analysis/lines`);
    return lineScoresResponseSchema.parse(response.data);
};

export const tournamentLineScoresQueryOptions = (tournamentId: number, teamId: number) =>
    queryOptions({
        queryKey: ["tournamentLineScores", tournamentId, teamId],
        queryFn: () => fetchTournamentLineScores(tournamentId, teamId),
        enabled: tournamentId > 0 && teamId > 0,
        staleTime: 5 * 60 * 1000,
    });
